"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var AppDefs = window.cccisd && window.cccisd.appDefs || {};
var _default = exports["default"] = function _default() {
  return AppDefs.app && AppDefs.app.resourceCenter || AppDefs.resourceCenters && AppDefs.resourceCenters.list || {};
};